module.exports = __webpack_public_path__ + "img/EDIT.0022ad16.svg";